import React from 'react';
import { useAdmissionsSummary } from '../../hooks/useAdmissions';

// Sidebar count of admissions that need a person. Silent when the API isn't
// there or nothing needs attention, so the sidebar never shows an error.
export default function AdmissionsBadge() {
  const { data } = useAdmissionsSummary(
    {},
    { staleTime: 2 * 60 * 1000, refetchInterval: 5 * 60 * 1000 }
  );
  const count = data?.needs_attention ?? 0;
  if (!count) return null;
  return (
    <span
      className="ml-auto rounded-full bg-red-600 px-1.5 text-[10px] font-semibold leading-4 text-white"
      title={`${count} admission${count === 1 ? '' : 's'} need attention`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
